import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const FounderSection = () => {
  return (
    <section className="py-16 md:py-20 bg-gray-50" data-testid="founder-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="flex flex-col md:flex-row items-center gap-8 md:gap-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <div className="flex-shrink-0">
            <img
              src="/assets/ollie-headshot-1.webp"
              alt="Dr Ollie Bell, founder of Kalobrate"
              className="w-28 h-28 md:w-36 md:h-36 rounded-full object-cover object-top border-4 border-golden"
            />
          </div>

          <div className="text-center md:text-left">
            <h2 className="text-xl sm:text-2xl font-heading font-bold text-carbon mb-3 tracking-tight">
              Led by Dr Ollie Bell
            </h2>
            <p className="text-base text-carbon/80 leading-relaxed mb-4 max-w-2xl">
              PhD in behaviour change. Specialist in workplace culture and men's health.
              Experience across manufacturing, engineering, energy, transport, hospitality and tech.
              Every Kalobrate project is led by Ollie directly.
            </p>
            <Link
              to="/about"
              className="text-sm font-semibold text-carbon hover:text-golden transition-colors inline-flex items-center"
              data-testid="founder-about-link"
            >
              More about Ollie <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FounderSection;
